import React from 'react'
import Link from 'gatsby-link'
import Logo from '../Logo'
import Popupmenu from '../Popupmenu'
import './index.scss'

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popupMenuActive: false,
    };
  }

  togglePopupMenu() {
    this.setState({
      popupMenuActive: !this.state.popupMenuActive,
    });
  }

  render() {
    const { popupMenuActive } = this.state;

    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">

            <Link to="/" className="navbar-brand">
              <Logo width="100" color="#3f50ae" />
            </Link>

            {/*
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item active">
                  <Link to="/" className="nav-link">Home</Link>
                </li>
                <li className="nav-item">
                  <Link to="/page-2/" className="nav-link">Go to page 2</Link>
                </li>
              </ul>
            </div>
            */}

          </div>
        </nav>

        {/*
        <button
          className={`burger-menu${popupMenuActive ? ' burger-menu-close' : ''}`}
          onClick={() => this.togglePopupMenu()}
          aria-label="Toggle navigation"
        >
          <div className="burger-menu-bar"></div>
          <div className="burger-menu-bar"></div>
          <div className="burger-menu-bar"></div>
        </button>

        <Popupmenu active={popupMenuActive} />
        */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js